// extracted by css-extract-rspack-plugin
var _1 = "aFY8ukdGgA9sucup";
var _2 = "vQ1qYwbl_uwcZ3vm";
var _3 = "fBJVe4Bby6on210n";
var _4 = "vQ1qYwbl_uwcZ3vm";
var _5 = "fBJVe4Bby6on210n";
var _6 = "ALThunOkuYaM9KuT";
var _7 = "ALThunOkuYaM9KuT";
var _8 = "pAlIfQgdMzonOGbA";
var _9 = "pAlIfQgdMzonOGbA";
var _a = "W7Py347BmrkREBwZ";
var _b = "W7Py347BmrkREBwZ";
var _c = "JjT92n3Ro0EodKLO";
var _d = "JjT92n3Ro0EodKLO";
var _e = "GACWf8PNqPkm68_l";
var _f = "GACWf8PNqPkm68_l";
var _10 = "VjWwzkOwMJcrpzoc";
var _11 = "k6B9yhagYpcjCZQv";
var _12 = "OPZs9vlTktIntuVB";
var _13 = "VjWwzkOwMJcrpzoc";
var _14 = "k6B9yhagYpcjCZQv";
var _15 = "OPZs9vlTktIntuVB";
var _16 = "F3fKOVsq6KQn680k";
var _17 = "F3fKOVsq6KQn680k";
var _18 = "tOuqXR9glx0wsl4D";
var _19 = "PurPAQf7q4YNHlCD";
var _1a = "YPhyNNIUcxIo_htl";
var _1b = "ALeP4C_V1tYn_qav";
var _1c = "aHmyEjDWJ2QIwlgz";
var _1d = "tl9hqVMFxhwv__ji";
var _1e = "T7N7YcYAQ07S456N";
var _1f = "PurPAQf7q4YNHlCD";
var _20 = "YPhyNNIUcxIo_htl";
var _21 = "ALeP4C_V1tYn_qav";
var _22 = "aHmyEjDWJ2QIwlgz";
var _23 = "tl9hqVMFxhwv__ji";
var _24 = "T7N7YcYAQ07S456N";
var _25 = "mqwu6QynKE3psxys";
var _26 = "hgC4pEB4rbMMDlwo";
var _27 = "QrFCeFW9i5cSrWLK";
var _28 = "KRf61u81oCMyry3A";
var _29 = "hgC4pEB4rbMMDlwo";
var _2a = "QrFCeFW9i5cSrWLK";
var _2b = "KRf61u81oCMyry3A";
var _2c = "tIV2ERtrGgynXgLW";
var _2d = "tIV2ERtrGgynXgLW";
export { _1 as "banner", _2 as "bannerLabel", _3 as "bannerSlot", _4 as "banner__label", _5 as "banner__slot", _6 as "coach-name", _7 as "coachName", _8 as "container--liveblog", _9 as "containerLiveblog", _a as "is-goalkeeper", _b as "isGoalkeeper", _c as "lineupPitch", _d as "lineup__pitch", _e as "match-lineups", _f as "matchLineups", _10 as "pitchContainer", _11 as "pitchTeam", _12 as "pitchTeamPlayer", _13 as "pitch__container", _14 as "pitch__team", _15 as "pitch__team-player", _16 as "player-identifier", _17 as "playerIdentifier", _18 as "playerlist", _19 as "playerlistContainer", _1a as "playerlistList", _1b as "playerlistPlayer", _1c as "playerlistTeam", _1d as "playerlistTitle", _1e as "playerlistWrap", _1f as "playerlist__container", _20 as "playerlist__list", _21 as "playerlist__player", _22 as "playerlist__team", _23 as "playerlist__title", _24 as "playerlist__wrap", _25 as "suspended", _26 as "team-name", _27 as "team-wrap", _28 as "team-wrap--away", _29 as "teamName", _2a as "teamWrap", _2b as "teamWrapAway", _2c as "with-tactical", _2d as "withTactical" }
